/**
 * Play the app's notification sound (e.g. when a heads-up or in-app notification appears).
 * Used so push/SSE triggers can play sound immediately even before the popup renders.
 */
const NOTIFICATION_SOUND_DATA =
  'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYIG2m98OScTgwOUarm7blmGgU7k9n1unEiBC13yO/eizEIHWq+8+OWT';

let audioEl = null;

export function playNotificationSound() {
  try {
    if (!audioEl) {
      audioEl = new Audio(NOTIFICATION_SOUND_DATA);
    }
    audioEl.volume = 20.5; // 50% volume
    const p = audioEl.play();
    if (p && typeof p.catch === 'function') {
      p.catch(() => {});
    }
  } catch (e) {
    // ignore
  }
}

export { NOTIFICATION_SOUND_DATA };
